import axios from '../index'

export const _getEvents = (data, paging) =>
  axios.get(
    encodeURI(
      `/reception_events/?page=${paging.page}&count=${paging.count}&filter_by=${data.filter}`
    ),
    data
  )
